import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import './css/CarListing.css';
import { getAllCars, Car } from '../components/CarData';

const CarListing: React.FC = () => {
    const navigate = useNavigate();
    const [cars] = useState<Car[]>(getAllCars());

    const handleCarClick = (carId: number) => {
        navigate(`/listing/${carId}`);
    };

    return (
        <div className="car-listing-container">
            <div className="container">
                <div className="car-grid">
                    {cars.map(car => (
                        <div key={car.id} className="car-card" onClick={() => handleCarClick(car.id)}>
                            <div className="car-image">
                                <img src={car.image} alt={car.title} />
                                {car.badge && <div className="car-badge">{car.badge}</div>}
                                <i className="far fa-heart"></i>
                            </div>
                            <div className="car-details">
                                <h3 className="car-title">{car.title}</h3>
                                <div className="car-price">{car.price}</div>
                                <div className="car-specs">
                                    <div className="car-spec"><i className="fas fa-gas-pump"></i> {car.engine}</div>
                                    <div className="car-spec"><i className="fas fa-cog"></i> {car.transmission}</div>
                                    <div className="car-spec"><i className="fas fa-road"></i> {car.mileage}</div>
                                </div>
                                <button className="view-details">Дэлгэрэнгүй</button>
                            </div>
                        </div>
                    ))}
                </div>


            </div>
        </div>
    );
};

export default CarListing;